import React from "react";
import { useParams, Routes, Route } from "react-router-dom";
import InsurancesView from "./InsurancesView/InsurancesView";
import BankingView from "./BankTransfersView/BankingView";
import SubsidiesManager from "../Subsidies/SubsidiesManager";
import FinanceDashboard from "../Finance/FinanceDashboard";
import RepositoryView from "./RepositoryView/RepositoryView";
import TripFinanceDetails from "../Finance/TripFinanceDetails";
import ParticipantsView from "./ParticipantsView/ParticipantsView";
import UserActionLogsView from "./UserActionLogsView/UserActionLogsView";
import RegistrationsView from "./RegistrationsView/RegistrationsView";
import GearsView from "./GearsView/GearsView";
import UfgRegisterView from "./UFGRegister/UfgRegisterView";
import ViewAccess from "./ViewAccess/ViewAccess";
import TrustedPersonView from "./TrustedPersonView/TrustedPersonView";
import HelpArticleView from "./HelpView/HelpArticleView";
import HelpView from "./HelpView/HelpView";
import InvoicesRegisterView from "./InvoicesRegisterView/InvoicesRegisterView";
import MembershipView from "./MembershipView/MembershipView.js";
import DiagnosticsView from "../Diagnostics/DiagnosticsView";

const ViewRenderer = () => {
  const { viewGuid } = useParams();

  const viewMap = {
    "35ff94ea-08cf-412d-86ca-e09c12d19ff9": "insurances",
    "3f8ef25c-20f6-43b9-97c9-75d5eda6bb09": "tripsParticipants",
    "ef015ec3-9f8c-4ec1-9b9c-48ce020848aa": "subsidies",
    "1d15ff0d-33e4-4a7c-82db-aaeb95430781": "banktransfers",
    "5c8bfd73-e91c-4199-aa45-39ae773da0ea": "finance",
    "c0ab9d5f-bbcb-46b1-b0a6-29d6426b9f20": "repository",
    "bbd7f720-2500-421d-ac8d-3cd0c28eb23a": "userLogs",
    "03930762-dc78-4c72-9a55-a56f58f07b24": "registrations",
    "c31c4393-cda8-4dff-bf29-3d8aaf9d54d3": "gears",
    "128d0343-72c1-4cf3-80cb-4af8631e22e0": "ufgRegisters",
    "c7c7ee0e-df58-40ec-a350-096398361dfa": "viewsAccess",
    // "fff88bf9-cc33-409e-b3da-b85fd9876b0f": "trustedPerson",
    "388d82d9-5225-4997-a3d8-8624ac7ff698": "help",
    "100f7fa5-fcfe-4fcf-bda5-9ce6a114fcab": "invoicesRegister",
    "7d8d7a73-90bb-4e79-ae49-5db449af57a7": "membership",
    "7f3c9e21-6b84-4d52-a917-3e8f4c1b2d60": "diagnostics"
  };

  const viewKey = viewMap[viewGuid];

  return (
    <div>
      <Routes>
        {viewKey === "insurances" && (
          <>
            <Route path="/" element={<InsurancesView />} />
            <Route path=":variantGuid" element={<InsurancesView />} />
          </>
        )}
        {viewKey === "banktransfers" && (
          <Route path="/" element={<BankingView />} />
        )}
       {viewKey === "subsidies" && (
          <Route path="/" element={<SubsidiesManager />} />
        )}

        {viewKey === "repository" && (
          <Route path="/" element={<RepositoryView  />} />
        )}

        {viewKey === "finance" && (
          <>
          <Route path="/" element={<FinanceDashboard />} />
          <Route path="trip/:tripGuid" element={<TripFinanceDetails />} />
          </>
        )}

        {viewKey === "tripsParticipants" && (
          <Route path="/" element={<ParticipantsView />} />
        )}

         {viewKey === "userLogs" && (
          <Route path="/" element={<UserActionLogsView />} />
        )}

        {viewKey === "registrations" && (
          <Route path="/" element={<RegistrationsView />} />
        )}

        {viewKey === "gears" && (
          <Route path="/" element={<GearsView />} />
        )}

        {viewKey === "ufgRegisters" && (
          <Route path="/*" element={<UfgRegisterView />} />
        )}
        
        {viewKey === "viewsAccess" && (
          <Route path="/" element={<ViewAccess />} />
        )}
        {/* {viewKey === "trustedPerson" && (
          <Route path="/" element={<TrustedPersonView />} />
        )} */}
        {viewKey === "invoicesRegister" && (
            <Route path="/" element={<InvoicesRegisterView />} />
        )}

        {viewKey === "membership" && (
          <Route path="/" element={<MembershipView />} />
        )}

        {viewKey === "diagnostics" && (
          <Route path="/" element={<DiagnosticsView />} />
        )}

        {viewKey === "help" && (
          <>
            <Route path="/" element={<HelpView />} />
            <Route path="article/:articleId" element={<HelpArticleView />} />
          </>
        )}
      </Routes>

    </div>
  );
};

export default ViewRenderer;
